import Fader from "../common/view/Fader";
import EventEmitter from "eventemitter3";

class Intro extends EventEmitter {
  // ---------------------------------------------------------------------------------------------------------
  // --	Intro
  // ---------------------------------------------------------------------------------------------------------

  constructor() {
    super();

    //初回フラグ
    this.isFirst = true;

    //DOM参照
    this.intro = $(".intro");

    //フェーダー
    this.fader = new Fader();
    this.fader.changeCategory("cat1");

    //ラインの初期位置
    this.intro.find(".intro__border span").each(function (index) {
      const line = $(this);
      switch (index) {
        case 0:
          gsap.set(line, { x: "100%" });
          break;
        case 1:
          gsap.set(line, { y: "100%" });
          break;
        case 2:
          gsap.set(line, { x: "-100%" });
          break;
        case 3:
          gsap.set(line, { y: "-100%" });
          break;
      }
    });

    //グループを非表示にする
    this.intro.find(".intro__group").each(function (index) {
      const group = $(this);
      group.hide();
    });

    //表示
    this.intro.css("display", "flex");
  }

  /**
   * イントロ表示
   */
  show(catIndex, callback) {
    //最初はすぐにタイトル表示
    if (this.isFirst) {
      this.isFirst = false;
      this.showTitle(catIndex);
    }
    //フェーダー表示してからタイトル表示
    else {
      this.fader.changeCategory("cat" + (catIndex + 1));
      this.fader.show(() => {
        this.showTitle(catIndex);
      });
    }
  }

  /**
   * タイトル表示
   */
  showTitle(catIndex) {
    //ラインの表示アニメーション
    this.intro.find(".intro__border span").each(function (index) {
      const line = $(this);
      switch (index) {
        case 0:
          gsap.set(line, { x: "100%" });
          gsap.to(line, 0.8, { x: "0%", ease: "power3.out" });
          break;
        case 1:
          gsap.set(line, { y: "100%" });
          gsap.to(line, 0.8, { y: "0%", ease: "power3.out" });
          break;
        case 2:
          gsap.set(line, { x: "-100%" });
          gsap.to(line, 0.8, { x: "0%", ease: "power3.out" });
          break;
        case 3:
          gsap.set(line, { y: "-100%" });
          gsap.to(line, 0.8, { y: "0%", ease: "power3.out" });
          break;
      }
    });

    //グループ表示
    this.currentGroup = this.intro.find(".intro__group").eq(catIndex);
    this.currentGroup.find("img").each(function (index) {
      const img = $(this);
      gsap.set(img, { y: 60, alpha: 0 });
      gsap.to(img, 0.8, {
        alpha: 1,
        y: 0,
        ease: "power3.out",
        delay: 0.1 * index,
      });
    });
    this.currentGroup.show();

    //一瞬間をあけてから隠す
    gsap.delayedCall(1, this.hideTitle.bind(this));
  }

  /**
   * タイトル費表示
   */
  hideTitle() {
    //イベント発行
    this.emit("READY");

    //グループ非表示
    this.currentGroup.find("img").each(function (index) {
      const img = $(this);
      gsap.to(img, 0.6, {
        alpha: 0,
        y: -30,
        ease: "power3.in",
        delay: 0.1 * index,
      });
    });

    //ラインの表示アニメーション
    this.intro.find(".intro__border span").each(function (index) {
      const line = $(this);
      switch (index) {
        case 0:
          gsap.to(line, 0.6, { x: "-100%", ease: "power3.in", delay: 0.2 });
          break;
        case 1:
          gsap.to(line, 0.6, { y: "-100%", ease: "power3.in", delay: 0.2 });
          break;
        case 2:
          gsap.to(line, 0.6, { x: "100%", ease: "power3.in", delay: 0.2 });
          break;
        case 3:
          gsap.to(line, 0.6, { y: "100%", ease: "power3.in", delay: 0.2 });
          break;
      }
    });

    //フェードアウト
    gsap.delayedCall(1.0, () => {
      this.fader.hide();
    });
  }

  // ---------------------------------------------------------------------------------------------------------
}

export default Intro;
